import { Dialog, DialogBody, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@cutilei/ui'
import cutileiApi from 'services/cutileiApi'
import AuthService from 'services/auth'
import submitOnEnter from 'utils/submitOnEnter'
import { Formik } from 'formik'
import ratingValidator from 'validators/ratingValidator'
import { ReactComponent as ButtonLoading } from 'icons/loading.svg'
import Rating from 'react-rating'
import * as FA from 'react-icons/fa'

import {
  Form,
  FormField,
  Row,
  Title,
  Input,
  InfoText,
  WarningText,
  Button
} from './styles'

export default function RateMemberModal ({
  visible,
  schedule,
  onConfirm: handleConfirm,
  onClose: handleClose
}) {
  const token = AuthService.getToken ()

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  return (
    <Dialog open={visible} onOpenChange={open => { if (!open) handleClose() }}>
      <DialogContent size='md' closeOnOutsideClick={false} aria-describedby={undefined}>
        <DialogHeader>
          <DialogTitle>Avaliar membro</DialogTitle>
        </DialogHeader>
        <Formik
          validationSchema={ratingValidator}
          initialValues={{
            'value': 0,
            'comment': ''
          }}
          onSubmit={async values => {
            const { data: memberRating } = await cutileiApi.post (
              `/members/${schedule.member?.id}/ratings`, {
                ...values,
                businessId: schedule.business.id,
                scheduleId: schedule.id
              }, requestConfig
            )

            handleConfirm (memberRating)
            handleClose ()
          }}
        >
          {({
            values,
            errors,
            touched,
            isSubmitting,
            handleChange,
            handleBlur,
            setFieldValue,
            handleSubmit
          }) => {
            return (
              <>
                <DialogBody>
                  <Form id='rate-member-form' onSubmit={handleSubmit} onKeyDown={submitOnEnter(handleSubmit)}>
                    <InfoText>
                      Como você avalia o membro atendido neste agendamento?
                    </InfoText>
                    <FormField style={{marginBottom: 20}}>
                      <Row>
                        <Rating
                          initialRating={values.value}
                          onChange={value => setFieldValue ('value', value)}
                          emptySymbol={<FA.FaStar color='#BEBEBE' size={20}/>}
                          fullSymbol={<FA.FaStar color='#FFC100' size={20}/>}
                        />
                        <Title style={{margin: 0}}>
                          {values.value > 0 ? values.value : ''}
                        </Title>
                      </Row>
                      {errors.value && touched.value && (
                        <WarningText>
                          {errors.value}
                        </WarningText>
                      )}
                    </FormField>
                    <FormField>
                      <Input
                        placeholder='Escreva um comentário sobre o membro (opcional para avliações de 4 e 5 estrelas)'
                        value={values.comment}
                        onChange={handleChange ('comment')} 
                        onBlur={handleBlur ('comment')}
                      />
                      {touched.comment && errors.comment && (
                        <WarningText>
                          {errors.comment}
                        </WarningText>
                      )}
                    </FormField>
                  </Form>
                </DialogBody>
                <DialogFooter>
                  <Button type='submit' form='rate-member-form'>
                    {isSubmitting ? <ButtonLoading/> : 'Enviar avaliação'}
                  </Button>
                </DialogFooter>
              </>
            )
          }}
        </Formik>
      </DialogContent>
    </Dialog>
  )
}
